import { useEffect, useState } from "react";
import { useSettings } from "@/lib/useSettings";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save, Plus, Trash2 } from "lucide-react";

export default function TeamScheduleSettings() {
  const { data, save } = useSettings();
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return <div className="text-slate-400">Lädt…</div>;

  const rows = f.schedule_template || [];
  const setRow = (i, patch) => setF({ ...f, schedule_template: rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)) });
  const addRow = () => setF({ ...f, schedule_template: [...rows, { name: "", days: 0 }] });
  const delRow = (i) => setF({ ...f, schedule_template: rows.filter((_, idx) => idx !== i) });

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Redaktions- und Produktionsteam</h2>
        <p className="text-sm text-slate-500">Wird in jeder Ausgabe im Magazin-Info-Panel angezeigt (Standardwerte für neue Ausgaben).</p>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Redaktionsleitung</Label><Input value={f.team_leitung} onChange={(e) => setF({ ...f, team_leitung: e.target.value })} className="mt-1" data-testid="team-leitung" /></div>
          <div><Label>Layout</Label><Input value={f.team_layout} onChange={(e) => setF({ ...f, team_layout: e.target.value })} className="mt-1" /></div>
          <div><Label>Redaktion</Label><Input value={f.team_redaktion} onChange={(e) => setF({ ...f, team_redaktion: e.target.value })} className="mt-1" /></div>
          <div><Label>Kontakt</Label><Input value={f.team_kontakt} onChange={(e) => setF({ ...f, team_kontakt: e.target.value })} className="mt-1" /></div>
        </div>
        <Button onClick={() => save({ team_leitung: f.team_leitung, team_layout: f.team_layout, team_redaktion: f.team_redaktion, team_kontakt: f.team_kontakt })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Team speichern</Button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Zeitplan-Vorlage</h2>
        <p className="text-sm text-slate-500">Termine werden automatisch anhand des Redaktionsschlusses berechnet – gib die Anzahl Tage nach Redaktionsschluss an.</p>
        <div className="space-y-2">
          {rows.map((r, i) => (
            <div key={i} className="flex items-center gap-2" data-testid={`schedule-row-${i}`}>
              <Input value={r.name} onChange={(e) => setRow(i, { name: e.target.value })} className="flex-1" placeholder="Termin-Bezeichnung" />
              <Input type="number" value={r.days} onChange={(e) => setRow(i, { days: Number(e.target.value) })} className="w-24" title="Tage nach Redaktionsschluss" />
              <span className="text-xs text-slate-400 w-14">Tage</span>
              <button onClick={() => delRow(i)} className="text-slate-400 hover:text-red-500"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <Button variant="outline" size="sm" onClick={addRow}><Plus size={15} className="mr-1.5" /> Termin hinzufügen</Button>
          <Button onClick={() => save({ schedule_template: rows })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Zeitplan speichern</Button>
        </div>
      </div>
    </div>
  );
}
